import React, { useState, useEffect, useCallback } from "react";
import UploadFile from "./UploadFile";
import { createUploadFile } from "../services/uploadFile.service";

export default function UploadFileRequest({
  id_expediente = null,
  requisito = { id_mov: null },
  id_usuario = null,
  saveClicked,
  setSaveClicked,
  callback
}) {
  const [fileSelectedext, setFileSelected] = useState([]);

  const addFiles = useCallback(async () => {
    try {
      if (fileSelectedext.length > 0) {
        const uploadResults = await Promise.all(
          fileSelectedext.map(async (file) => {
            const result = await createUploadFile(
              file.file,
              id_expediente,
              requisito?.id_mov,
              null,
              null,
              id_usuario
            );

            if (result.status === 200) {
              return result;
            }
            return null;
          })
        );
        callback(uploadResults);
        setSaveClicked(false)
      } else {
        callback(null);
      }
    } catch (error) {
      callback(null);
      console.log("Failed to add selection", error);
    }
  }, [fileSelectedext, id_expediente, requisito, id_usuario, callback]);

  const handleCompleteSelection = async (selection) => {
    console.log("Archivo seleccionado", selection);
  };

  useEffect(() => {
    if (saveClicked) {
      addFiles(); // Llama directamente la función de subida
    }
  }, [saveClicked, addFiles]);

  return (
    <>
      <UploadFile
        setFileSelected={setFileSelected}
        fileSelectedext={fileSelectedext}
        onCompleteFileSelection={handleCompleteSelection}
      />
    </>
  );
}
